import { JSON_ADAPTER_TYPE, type JsonAdapter } from "inversify-utils-kit";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { registerSW } from "virtual:pwa-register";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";

import en from "@/i18n/locales/en.json";
import es from "@/i18n/locales/es.json";

import App from "./App.vue";
import "./assets/main.css";
import { HOST, SITE_TITLE } from "./common/constants";
import { AppContainer } from "./config";
import router from "./router";

const app = createApp(App);
app.config.globalProperties.$publicUrl = HOST;
app.config.globalProperties.$siteTitle = SITE_TITLE;
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);

const jsonAdapter = AppContainer.get<JsonAdapter>(JSON_ADAPTER_TYPE);
app.provide("jsonAdapter", jsonAdapter);
app.use(createMetaManager());
app.use(
    createI18n({
        locale: "es",
        fallbackLocale: "en",
        messages: { en, es },
        globalInjection: true
    })
);
app.use(metaPlugin);
app.mount("#app");

const updateSW = registerSW({
    onNeedRefresh() {
        if (confirm("Hay una nueva versión disponible. ¿Deseas actualizar?")) {
            updateSW(true);
        }
    },
    onOfflineReady() {
        console.log("Aplicación lista para usarse sin conexión");
    }
});
